import { imageArrayPropType } from './sharedPropTypes';
import PropTypes from 'prop-types';
const ImageGallery = ({ images, onImageClick }) => (
  <div className="collectiblesContainer">
    {images.map((img, index) => (
      <div 
        key={index} 
        className="collectiblesItem"
        onClick={() => onImageClick(img)}
        style={{
          cursor: 'pointer',
          transition: 'transform 0.2s ease'
        }}
      >
        <img 
          src={typeof img === 'string' ? img : img.src} 
          alt={typeof img === 'string' ? '' : img.alt || ''}
          className="collectiblesCatalogue"
        />
      </div>
    ))}
  </div>
);

ImageGallery.propTypes = {
  images: imageArrayPropType.isRequired,
  onImageClick: PropTypes.func.isRequired
};

export default ImageGallery;